import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-risk-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './risk-section.component.html',
  styles: [
    `
      .section-banner {
        display: flex;
        align-items: center;
        gap: 0.6rem;
        padding: 0.85rem 1.25rem;
        font-weight: 700;
        font-size: 1.05rem;
        border-radius: 6px 6px 0 0;
        background-color: #ffc107;
        color: #1a1a1a;
      }
      .section-banner i {
        font-size: 1.2rem;
      }
      .section-banner-body {
        padding: 1rem 1.25rem;
        border: 1px solid #dee2e6;
        border-top: none;
        border-radius: 0 0 6px 6px;
        background: #fff;
      }
    `,
  ],
})
export class RiskSectionComponent {
  readonly riskAssessments = input.required<any[]>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'final') return { color: 'bg-success', label: 'Final' };
    if (s === 'registered') return { color: 'bg-primary', label: 'Registrado' };
    if (s === 'preliminary') return { color: 'bg-warning text-dark', label: 'Preliminar' };
    if (s === 'cancelled') return { color: 'bg-danger', label: 'Cancelado' };
    return { color: 'bg-secondary', label: status || 'N/A' };
  }

  getRiskName(risk: any): string {
    return (
      risk.code?.text || risk.code?.coding?.[0]?.display || risk.code?.coding?.[0]?.code || '—'
    );
  }

  getOccurrenceDate(risk: any): string {
    return risk.occurrenceDateTime || risk.occurrencePeriod?.start || '';
  }

  getMitigation(risk: any): string {
    return risk.mitigation || '';
  }

  getPredictions(risk: any): any[] {
    return risk.prediction || [];
  }

  getPredictionOutcome(pred: any): string {
    return pred.outcome?.text || pred.outcome?.coding?.[0]?.display || '—';
  }

  getPredictionProb(pred: any): string {
    if (pred.probabilityDecimal !== undefined)
      return `${(pred.probabilityDecimal * 100).toFixed(0)}%`;
    if (pred.probabilityRange) {
      const low = pred.probabilityRange.low?.value ?? '';
      const high = pred.probabilityRange.high?.value ?? '';
      return `${low}–${high}`;
    }
    return '—';
  }
}
